// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"aP-z","categoryName":"bP-z","categoryNameSearchHeader":"cP-z","categoryContent":"dP-z","bottomAligned":"eP-z","image":"fP-z","imageNoBackground":"gP-z"};